export const PRINT_PAGE_STYLE = `
      @page {
        size: auto;
        margin: 0;
      }

      @media print {
        html, body {
          height: initial !important;
          overflow: initial !important;
          -webkit-print-color-adjust: exact;
        }

        /* Keep printed version more compact */
        table th {
          font-size: 10pt !important;
        }

        table td {
          padding: 0.5rem !important;
        }

        /* Prevent page breaks inside table rows */
        table tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        /* Allow page breaks after rows */
        table tr {
          page-break-after: auto;
          break-after: auto;
        }

        /* Keep table headers on each page */
        thead {
          display: table-header-group;
        }

        /* Prevent orphaned rows */
        table tbody tr:last-child {
          page-break-after: auto;
        }
      }
    `
